export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo/src/constant.js
// module id = 312
// module chunks = 0